const savedFeedIdsKey = "protea.environmental-feed.saved";

export function loadSavedEnvironmentalSignalIds(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(savedFeedIdsKey);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed)
      ? parsed.filter((value): value is string => typeof value === "string")
      : [];
  } catch {
    return [];
  }
}

export function persistSavedEnvironmentalSignalIds(ids: string[]) {
  try {
    window.localStorage.setItem(savedFeedIdsKey, JSON.stringify(ids));
  } catch {
    // El guardado local es opcional; la señal sigue disponible durante la sesión.
  }
}
